import { Media } from './media.model';

export class BackgroundMedia {
  Image?: Media;
  Video?: Media;
  BackgroundColor: string = '';
  BackgroundImageSize?: string;
  BackgroundImageRepeat?: string;
  BackgroundImagePosition?: string;
  Quality: number = 100;
  Changed: boolean = false;
}
